import { convertToSentenceCase } from "../../../utilities/commonUtilities";
import { LABELS } from "../../labels/chatLog.labels";
import moment from "moment";

export const changeLog = (oldName: string, newName: string): Array<any> => {
    return [
        {
            title: `${LABELS?.change}`,
            dataIndex: "columnName",
            key: "columnName",
            width: "20%",
            render: (_: string, record: { columnName: string }) => (
                <>
                    {record?.columnName && convertToSentenceCase(record?.columnName)}
                </>
            )
        },
        {
            title: `${LABELS?.lastChange}`,
            dataIndex: "createdOn",
            key: "createdOn",
            width: "20%",
            render: (_: string, record: { createdOn: string }) => (
                <>
                    {record?.createdOn && moment.utc(record.createdOn).local().format("DD/MM/YYYY, hh.mm A")}
                </>
            )
        },
        {
            title: `${LABELS?.changedBy}`,
            dataIndex: "createdByName",
            key: "createdByName",
            width: "20%",
        },
        {
            title: `${oldName}`,
            dataIndex: "oldValue",
            key: "oldValue",
            width: "20%",
        },
        {
            title: `${newName}`,
            dataIndex: "newValue",
            key: "newValue",
            width: "20%",
        },
    ]
};

export const mockChangeLogData = [
    {
        "id": 1,
        "caseId": "7a24e83d-233f-49ea-81ef-fdeff8613fcd",
        "oldValue": "TestProjectR2_copy433",
        "newValue": "TestProjectR2_copy434",
        "tableName": "DR_ProjectValues",
        "columnName": "ProjectName",
        "copyFrom": "55b56178-cb8c-4248-8ff1-b3bf9ce7cc5d",
        "createdBy": 11837,
        "createdOn": "2025-08-08T11:28:58.307",
        "createdByName": "Rajashekhar Hosamani"
    },
    {
        "id": 1,
        "caseId": "7a24e83d-233f-49ea-81ef-fdeff8613fcd",
        "oldValue": "TestProjectR2_copy433",
        "newValue": "TestProjectR2_copy434",
        "tableName": "DR_ProjectValues",
        "columnName": "ProjectName",
        "copyFrom": "55b56178-cb8c-4248-8ff1-b3bf9ce7cc5d",
        "createdBy": 11837,
        "createdOn": "2025-08-08T11:28:58.307",
        "createdByName": "Rajashekhar Hosamani"
    },
    {
        "id": 1,
        "caseId": "7a24e83d-233f-49ea-81ef-fdeff8613fcd",
        "oldValue": "TestProjectR2_copy433",
        "newValue": "TestProjectR2_copy434",
        "tableName": "DR_ProjectValues",
        "columnName": "ProjectName",
        "copyFrom": "55b56178-cb8c-4248-8ff1-b3bf9ce7cc5d",
        "createdBy": 11837,
        "createdOn": "2025-08-08T11:28:58.307",
        "createdByName": "Rajashekhar Hosamani"
    },
    {
        "id": 1,
        "caseId": "7a24e83d-233f-49ea-81ef-fdeff8613fcd",
        "oldValue": "TestProjectR2_copy433",
        "newValue": "TestProjectR2_copy434",
        "tableName": "DR_ProjectValues",
        "columnName": "ProjectName",
        "copyFrom": "55b56178-cb8c-4248-8ff1-b3bf9ce7cc5d",
        "createdBy": 11837,
        "createdOn": "2025-08-08T11:28:58.307",
        "createdByName": "Rajashekhar Hosamani"
    },
    {
        "id": 1,
        "caseId": "7a24e83d-233f-49ea-81ef-fdeff8613fcd",
        "oldValue": "TestProjectR2_copy433",
        "newValue": "TestProjectR2_copy434",
        "tableName": "DR_ProjectValues",
        "columnName": "ProjectName",
        "copyFrom": "55b56178-cb8c-4248-8ff1-b3bf9ce7cc5d",
        "createdBy": 11837,
        "createdOn": "2025-08-08T11:28:58.307",
        "createdByName": "Rajashekhar Hosamani"
    }
];